export const frontendBaseUrl = import.meta.env.VITE_FRONTEND_DOMAIN;
export const baseURL = import.meta.env.VITE_BACKEND_DOMAIN;
export const fileServerUrl = import.meta.env.VITE_BACKEND_DOMAIN + "/";
export const appName = import.meta.env.VITE_APP_NAME;
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api";
//console.log(frontendBaseUrl,baseURL,fileServerUrl,appName,apiBaseUrl);

//===================== private/public api prefix ==============================
export const API_URL = baseURL;
// export const API_END_POINT = API_URL + "/api/";
export const API_END_POINT = apiBaseUrl + "/";
// export const prefix = baseURL + "/api/auth/";
export const prefix = apiBaseUrl + "/auth/";
export const lcTrackingUrl = prefix + "lc-tracking";
export const lcTrackingPublicUrl = apiBaseUrl + "/lc-tracking/shared";
// export const prefixPublic = baseURL + "/api/";

//===================== users login/logout ==============================
export const userLoginUrl = API_END_POINT + "user/login";
export const userLogoutUrl = prefix + "administration/user/logout";

export const userLoginRefreshUrl = prefix + "administration/user/login/refresh"

//===================== Administration ==============================
//Module
export const saveUpdateModuleSetup = prefix + "administration/save-update-module";
export const getModuleList = prefix + "administration/get-module-list";
export const deleteModule = prefix + "administration/delete-module";
//Sub Module
export const saveUpdateSubModuleSetup = prefix + "administration/save-update-sub-module";
export const getSubModuleList = prefix + "administration/get-sub-module-list";
export const deleteSubModule = prefix + "administration/delete-sub-module";
//Menu
export const saveUpdateMenuSetup = prefix + "administration/save-update-menu";
export const getMenuList = prefix + "administration/get-menu-list";
export const deleteMenu = prefix + "administration/delete-menu";
//Role
export const saveUpdateRole = prefix + "administration/save-update-role";
export const getRoleList = prefix + "administration/get-role-list";
export const deleteRole = prefix + "administration/delete-role";
export const getModulesByBranch = prefix + "administration/get-module-by-branch";
//Role Permission
export const saveRolePermission = prefix + "administration/save-role-permission";
export const getRolePermission = prefix + "administration/get-role-permission";
//Company Management
export const getCompanyList = prefix + "administration/get-company-list";
export const saveUpdateCompany = prefix + "administration/save-update-company";
//Company Module Management
export const getCompanyModuleList = prefix + "administration/get-company-module-list";
export const saveUpdateCompanyModule = prefix + "administration/save-update-company-module";
//Branch Management
export const getBranchList = prefix + "administration/get-branch-list";
export const saveUpdateBranchSetup = prefix + "administration/save-update-branch";
export const deleteBranch = prefix + "administration/delete-branch";
export const changeBranch = prefix + "administration/change-branch";
//Branch Module Management
export const getBranchModuleList = prefix + "administration/get-branch-module-list";
export const getBranchWiseModuleList = prefix + "administration/get-branch-wise-module-list";

export const saveUpdateBranchModule = prefix + "administration/save-update-branch-module";
//User Management
export const getUsersList = prefix + "administration/get-user-list";
export const saveUpdateUserSetup = prefix + "administration/save-update-user";
export const deleteUser = prefix + "administration/delete-user";
export const updateUserPassword = prefix + "administration/change-password";
export const saveUserRolePermission = prefix + "administration/save-user-role-permission";
export const getUserPermission = prefix + "administration/get-user-permission";
// Approval Management
export const saveUpdateApprovalName = prefix + "administration/save-update-approval-name";
export const getApprovalNameList = prefix + "administration/get-approval-name";
export const saveUpdateApprovalMatrix = prefix + "administration/save-update-approval-matrix";
export const getApprovalMatrixList = prefix + "administration/get-approval-matrix";
export const getApprovalMatrixById = prefix + "administration/get-approval-matrix-by-id";
export const getApprovalStepNames = prefix + "administration/approval-step-status-names";
export const getApprovalRequestRecord = prefix + "administration/approval-request-record";
export const getApprovalRequestDetails = prefix + "administration/approval-request-details";
export const updateApprovalStatus = prefix + "administration/approval-status/update";
export const updateItemData= prefix + "administration/update-item-data";

// Notification Management
export const getNotifications = prefix + "administration/notifications";
export const markNotificationAsRead = prefix + "administration/notifications/read";
export const markAllNotificationsAsRead = prefix + "administration/notifications/read-all";

// Pusher Credentials
export const getPusherCredentials = prefix + "administration/pusher-credentials";

//===================== Inventory ==============================
//Warehouse Management
export const getWarehouseList = prefix + "inventory/get-warehouse-list";
export const saveUpdateWarehouse = prefix + "inventory/save-update-warehouse";
export const deleteWarehouse = prefix + "inventory/delete-warehouse";
export const generateWarehouseCode = prefix + "inventory/generate-warehouse-code";

//Customer Kpi Setup
export const getInvCustomerKpisList = prefix + "master-data/kpi";
export const saveInvCustomerKpi = prefix + "master-data/kpi"
export const updateInvCustomerKpi = prefix + "master-data/kpi"
export const getInvCustomerKpiById = prefix + "master-data/kpi"

//Customer Kpi Assign Setup
export const getInvCustomerKpiAssignmentsList = prefix + "master-data/kpi-assigns";
export const saveInvCustomerKpiAssignment = prefix + "master-data/kpi-assigns"
export const getInvCustomerKpiAssignmentById = prefix + "master-data/kpi-assigns"


//Brand Management
export const getBrandList = prefix + "inventory/get-brand-list";
export const saveUpdateBrand = prefix + "inventory/save-update-brand";
export const deleteBrand = prefix + "inventory/delete-brand";
export const generateBrandCode = prefix + "inventory/generate-brand-code";

//Color Management
export const getColorList = prefix + "inventory/get-color-list";
export const saveUpdateColor = prefix + "inventory/save-update-color";

//Manufacture Management
export const getManufactureList = prefix + "inventory/get-manufacture-list";
export const saveUpdateManufacture = prefix + "inventory/save-update-manufacture";
export const deleteManufacture = prefix + "inventory/delete-manufacture";
export const changeManufacture = prefix + "inventory/change-manufacture";
export const generateManufactureCode = prefix + "inventory/generate-manufacture-code";

//Unit Management
export const getUnitList = prefix + "inventory/get-unit-list";
export const saveUpdateUnit = prefix + "inventory/save-update-unit";
export const deleteUnit = prefix + "inventory/delete-unit";
export const generateUnitCode = prefix + "inventory/generate-unit-code";

//Size Management
export const getSizeList = prefix + "inventory/get-size-list";
export const saveUpdateSize = prefix + "inventory/save-update-size";
export const deleteSize = prefix + "inventory/delete-size";

//Product Type Management
export const getProductTypeList = prefix + "inventory/get-product-type-list";
export const saveUpdateProductType = prefix + "inventory/save-update-product-type";

//Secondary Unit Management
export const getSecondaryUnitList = prefix + "inventory/get-secondary-unit-list";
export const saveUpdateSecondaryUnit = prefix + "inventory/save-update-secondary-unit";

//Category Management
export const getCategoryList = prefix + "inventory/get-category-list";
export const saveUpdateCategory = prefix + "inventory/save-update-category";
export const deleteCategory = prefix + "inventory/delete-category";
export const generateCategoryCode = prefix + "inventory/generate-category-code";

//Sub Category Management
export const getSubCategoryList = prefix + "inventory/get-sub-category-list";
export const saveUpdateSubCategory = prefix + "inventory/save-update-sub-category";
export const deleteSubCategory = prefix + "inventory/delete-sub-category";
export const generateSubCategoryCode = prefix + "inventory/generate-sub-category-code";

//Product Management
export const getProductList = prefix + "inventory/get-product-list";
export const saveUpdateProduct = prefix + "inventory/save-update-product";
export const deleteProduct = prefix + "inventory/delete-product";
export const changeProduct = prefix + "inventory/change-product";
export const generateProductCode = prefix + "inventory/generate-product-code";
export const importProductCSV = prefix + "inventory/import-product-csv";

//Product Mapping Management
export const getProductMapList = prefix + "inventory/get-product-map-list";
export const saveUpdateProductMap = prefix + "inventory/save-update-product-map";

//Supplier Type Management
export const getSupplierTypeList = prefix + "inventory/get-supplier-type-list";
export const saveUpdateSupplierType = prefix + "inventory/save-update-supplier-type";
export const deleteSupplierType = prefix + "inventory/delete-supplier-type";

//Supplier Management
export const getSupplierList = prefix + "inventory/get-supplier-list";
export const getSupplierById = prefix + "inventory/get-supplier-by-id";
export const saveUpdateSupplier = prefix + "inventory/save-update-supplier";
export const deleteSupplier = prefix + "inventory/delete-supplier";

// Inv Issue Management
export const getInvIssueList = prefix + "inventory/get-inv-issue-list";
export const saveUpdateInvIssue = prefix + "inventory/save-update-inv-issue";
export const getInvIssueById = prefix + "inventory/get-inv-issue-by-id";

// Inv Requisition Delivery Management
export const getInvRequisitionDeliveryList = prefix + "inventory/get-inv-requisition-delivery-list";
export const saveUpdateInvRequisitionDeliveryList = prefix + "inventory/save-update-inv-requisition-delivery";
export const getInvRequisitionDeliveryById = prefix + "inventory/get-inv-requisition-delivery-by-id";
export const saveUpdateInvProductionRequisitionDelivery = prefix + "inventory/save-update-inv-production-requisition-delivery";
export const getInvProductionRequisitionDeliveryList = prefix + "inventory/get-inv-production-requisition-delivery-list";
export const getInvProductionRequisitionDeliveryById = prefix + "inventory/get-inv-production-requisition-delivery-by-id";
export const getInvProductionRequisitionLots = (rawDetailId) => prefix + `inventory/production-requisition-lots/${rawDetailId}`;

// Inv Sale Invoice Delivery Management
export const getInvSalesInvoiceDeliveryList = prefix + "inventory/get-inv-sales-invoice-delivery-list";
export const saveUpdateInvSalesInvoiceDelivery = prefix + "inventory/save-update-inv-sales-invoice-delivery";
export const getInvSalesInvoiceDeliveryById = prefix + "inventory/get-inv-sales-invoice-delivery-by-id";
export const deliveredSalesInvoiceList = prefix + "inventory/get-inv-delivered-sales-invoice-list";

// Inv Sample Delivery Management
export const getInvSampleDeliveryList = prefix + "inventory/sample-deliveries";
export const saveUpdateInvSampleDelivery = prefix + "inventory/sample-deliveries";
export const getInvSampleDeliveryById = prefix + "inventory/sample-deliveries";
export const getInvApprovedSampleDeliveryList = prefix + "inventory/sample-deliveries-approved-list";

// Inv Gate Pass Management
export const getInvGatePassList = prefix + "inventory/get-inv-sales-delivery-gate-pass-list";
export const saveUpdateInvGatePass = prefix + "inventory/save-update-inv-sales-delivery-gate-pass";
export const getInvGatePassById = prefix + "inventory/get-inv-sales-delivery-gate-pass-by-id";

// Direct Receive Management
export const getInvDirectReceiveList = prefix + "inventory/get-inv-dr-receive-list";
export const saveUpdateInvDirectReceive = prefix + "inventory/save-update-inv-dr-receive";
export const getInvDirectReceiveById = prefix + "inventory/get-inv-dr-receive-by-id";

// PO Receive Management
export const getInvPoReceiveList = prefix + "inventory/get-inv-po-receive-list";
export const saveUpdateInvPoReceive = prefix + "inventory/save-update-inv-po-receive";
export const getInvPoReceiveById = prefix + "inventory/get-inv-po-receive-by-id";
export const receivedPoList = prefix + "inventory/get-inv-received-po-list";

// LC Receive Management
export const saveUpdateInvLcReceive = prefix + "inventory/save-update-lc-receive";
export const lcReceiveRecord = prefix + "inventory/lc-receive-records";
export const lcReceiveById = prefix + "inventory/get-lc-receive-by-id";

//Return Management
export const purchaseReturn = prefix + "inventory/store-purchase-return";
export const purchaseReturnRecord = prefix + "inventory/purchase-return-record";
export const purchaseReturnDetails = prefix + "inventory/purchase-return-details";
// export const purchaseReturnDetailsForEdit = prefix + "inventory/purchase-return-edit";   

export const salesReturn = prefix + "inventory/store-sales-return";
export const salesReturnRecord = prefix + "inventory/sales-return-record";
export const salesReturnDetails = prefix + "inventory/sales-return-details";


// Item Transfer
export const getInvItemTransferList = prefix + "inventory/get-inv-item-transfer-list";
export const saveUpdateInvItemTransfer = prefix + "inventory/save-update-inv-item-transfer";
export const getInvItemTransferById = prefix + "inventory/get-inv-item-transfer-by-id";

// Inventory Records
export const getInventoryRecordsList = prefix + "inventory/inventory-list";
export const getInventoryRecordDetails = prefix + "inventory/inventory-details";

// Inventory Details (Transaction Log)
export const getInventoryDetailsList = prefix + "inventory/inventory-details";
export const getInventoryBatchList = prefix + "inventory/inventory-product-batch";
export const getInventoryAlertStockSummary = prefix + "inventory/inventory-alert-stock-summary";

// production Receive
export const saveUpdateInvProductionReceive = prefix + "inventory/save-update-inv-production-receive";
export const getInvProductionReceiveList = prefix + "inventory/get-inv-production-receive-list";
export const getInvProductionReceiveById = prefix + "inventory/get-inv-production-receive-by-id";

// Reports Management
export const getInvStockReport = prefix + "inventory/reports/stock-report";
export const getInvIssueReport = prefix + "inventory/reports/issue-report";
export const getInvItemsReport = prefix + "inventory/reports/items-list";
export const getInvDamageExpireReport = prefix + "inventory/reports/damage-expire-report";
export const getInvDeliveryReport = prefix + "inventory/reports/delivery-report";
export const getInvTransferReport = prefix + "inventory/reports/transfer-report";
export const getInvReturnReport = prefix + "inventory/reports/return-report";
export const getInvGatepassReport = prefix + "inventory/reports/gatepass-report";
export const getInvGeneralRequisitionReport = prefix + "inventory/reports/general-requisition-report";
export const getInvItemReceivedReport = prefix + "inventory/reports/item-received-report";
export const getInvPoReceiveReport = prefix + "inventory/reports/po-receive-report";
export const getInvLcReceiveReport = prefix + "inventory/reports/lc-receive-report";
export const getInvDirectReceiveReport = prefix + "inventory/reports/direct-receive-report";

//------------------------ Supplier Management -----------------------

//Supplier Mapping Management
export const getSupplierMapList = prefix + "inventory/get-supplier-map-list";
export const saveUpdateSupplierMap = prefix + "inventory/save-update-supplier-map";
export const deleteSupplierMap = prefix + "inventory/delete-supplier-map";

// Requisition Management
export const getInvRequisitionList = prefix + "inventory/get-inv-requisition-list";
export const getInvDueRequisitionList = prefix + "inventory/get-inv-due-requisition-list";
export const saveInvUpdateRequisition = prefix + "inventory/save-update-inv-requisition";
export const getInvRequisitionById = prefix + "inventory/get-inv-requisition-by-id";
export const getInvDueRequisitionById = prefix + "inventory/get-inv-due-requisition-by-id";

// Customer Management
export const getCustomerList = prefix + "inventory/get-customer-list";
export const saveUpdateCustomer = prefix + "inventory/save-update-customer";
export const deleteCustomer = prefix + "inventory/delete-customer";
export const getCustomerById = prefix + "inventory/get-customer-by-id";

// Customer Type Management
export const getCustomerTypeList = prefix + "inventory/get-customer-type-list";
export const saveUpdateCustomerType = prefix + "inventory/save-update-customer-type";
export const deleteCustomerType = prefix + "inventory/delete-customer-type";

//Supplier Mapping Management
export const getCustomerMapList = prefix + "inventory/get-customer-map-list";
export const saveUpdateCustomerMap = prefix + "inventory/save-update-customer-map";
export const deleteCustomerMap = prefix + "inventory/delete-customer-map";

// Inv Country Management
export const getInvCountryList = prefix + "inventory/get-inv-country-list";

// Bangladesh Location Management
export const getDivisionList = prefix + "bangladesh/divisions";
export const getDistrictList = prefix + "bangladesh/districts";
export const getUpazilaList = prefix + "bangladesh/upazilas";
export const searchLocation = prefix + "bangladesh/search";
export const getLocationHierarchy = prefix + "bangladesh/hierarchy";

//===================== HRM ==============================

//Employee Kpi Setup
export const getHrmEmployeeKpisList = prefix + "master-data/kpi";
export const saveHrmEmployeeKpi = prefix + "master-data/kpi"
export const updateHrmEmployeeKpi = prefix + "master-data/kpi"
export const getHrmEmployeeKpiById = prefix + "master-data/kpi"

//Employee Kpi Assign Setup
export const getHrmEmployeeKpiAssignmentsList = prefix + "master-data/kpi-assigns";
export const saveHrmEmployeeKpiAssignment = prefix + "master-data/kpi-assigns"
export const updateHrmEmployeeKpiAssignment = prefix + "master-data/kpi-assigns"
export const getHrmEmployeeKpiAssignmentById = prefix + "master-data/kpi-assigns"

//Letter setup
export const getHrmLetterInfo = prefix + "hrm/get-letter-info-list";
export const saveUpdateHrmLetterInfo = prefix + "hrm/save-update-letter-info";
export const saveUpdateHrmLetter = prefix + "hrm/save-update-letter";
export const getHrmLetterInfoById = prefix + "hrm/get-letter-info";

// Department
export const getHrmDepartmentList = prefix + "hrm/get-department-list";
export const saveUpdateHrmDepartment = prefix + "hrm/save-update-department";

// Section
export const getHrmSectionList = prefix + "hrm/get-section-list";
export const saveUpdateHrmSection = prefix + "hrm/save-update-section";

// Designation
export const getHrmDesignationList = prefix + "hrm/get-designation-list";
export const saveUpdateHrmDesignation = prefix + "hrm/save-update-designation";

// Employee Type
export const getHrmEmployeeTypeList = prefix + "hrm/get-employee-type-list";
export const getHrmTeamWiseEmployeeList = prefix + "sales/sales-teams-wise-employees";
export const saveUpdateHrmEmployeeType = prefix + "hrm/save-update-employee-type";

// Blood Group
export const getHrmBloodGroupList = prefix + "hrm/get-blood-group-list";

// Gender
export const getHrmGenderList = prefix + "hrm/get-gender-list";

// Gender
export const getHrmPaymentReasonList = prefix + "hrm/get-payment-reason-list";

// Religion
export const getHrmReligionList = prefix + "hrm/get-religion-list";

// Marital Status
export const getHrmMaritalStatusList = prefix + "hrm/get-marital-status-list";

// Employee Bank Setup
export const getHrmEmployeeBankSetupList = prefix + "hrm/banks";
export const getHrmEmployeeBankSetupById = prefix + "hrm/banks";
export const saveUpdateHrmEmployeeBankSetup = prefix + "hrm/banks/store";

//Nominee
export const saveUpdateHrmNominee = prefix + "hrm/save-update-nominee";
export const getHrmNomineeList = prefix + "hrm/get-nominee-list";

// Employee
export const saveUpdateEmployeeSetup = prefix + "hrm/save-update-employee";
export const getHrmEmployeeList = prefix + "hrm/get-employee-list";
export const getEmployeeDetails = prefix + "hrm/get-employee-details";
export const getEmployeeDetailsByUser = prefix + "hrm/get-employee-details-by-user";

export const getHrmEmployeePermissionWiseList = prefix + "hrm/get-employee-permission-wise-list";

// Employee HOD Setup
export const saveUpdateHrmHOD = prefix + "hrm/save-update-employee-hod";
export const getHrmHODList = prefix + "hrm/get-employee-hod-list";

// Educational Information
export const getEducationalInfoList = prefix + "hrm/get-educational-info-list";
export const saveUpdateEducationalInfo = prefix + "hrm/save-update-educational-info";
export const getEducationalInfoById = prefix + "hrm/get-educational-info";
export const deleteEducationalInfo = prefix + "hrm/delete-educational-info";
export const getEducationalInfoByEmployee = (employeeId) => prefix + `hrm/get-educational-info-by-employee/${employeeId}`;
export const getEducationalInfoGroupedByEmployee = (id) => prefix + `hrm/get-educational-info-grouped-by-employee/${id}`;
export const saveEmployeeEducationalInfo = prefix + "hrm/save-employee-educational-info";
export const updateEducationalInfo = (id) => prefix + `hrm/update-educational-info/${id}`;
export const bulkDeleteEducationalInfo = prefix + "hrm/bulk-delete-educational-info";

// Address Information
export const getAddressInfoList = prefix + "hrm/get-address-info-list";
export const getAddressInfoById = (id) => prefix + `hrm/get-address-info/${id}`;
export const getAddressInfoByEmployee = (id) => prefix + `hrm/get-address-info-by-employee/${id}`;
export const saveUpdateAddressInfo = prefix + "hrm/save-update-address-info";
export const saveEmployeeAddressInfo = prefix + "hrm/save-employee-address-info";
export const updateAddressInfo = (id) => prefix + `hrm/update-address-info/${id}`;
export const deleteAddressInfo = (id) => prefix + `hrm/delete-address-info/${id}`;

// Previous Employment Information
export const getPreviousEmploymentInfoList = prefix + "hrm/get-previous-employment-info-list";
export const getPreviousEmploymentInfoById = (id) => prefix + `hrm/get-previous-employment-info/${id}`;
export const getPreviousEmploymentInfoByEmployee = (id) => prefix + `hrm/get-previous-employment-info-by-employee/${id}`;
export const saveUpdatePreviousEmploymentInfo = prefix + "hrm/save-update-previous-employment-info";
export const saveEmployeePreviousEmploymentInfo = prefix + "hrm/save-employee-previous-employment-info";
export const updatePreviousEmploymentInfo = (id) => prefix + `hrm/update-previous-employment-info/${id}`;
export const deletePreviousEmploymentInfo = (id) => prefix + `hrm/delete-previous-employment-info/${id}`;

// Other Information
export const getOtherInfoList = prefix + "hrm/get-other-info-list";
export const getOtherInfoById = (id) => prefix + `hrm/get-other-info/${id}`;
export const getOtherInfoByEmployee = (id) => prefix + `hrm/get-other-info-by-employee/${id}`;
export const saveUpdateOtherInfo = prefix + "hrm/save-update-other-info";
export const saveEmployeeOtherInfo = prefix + "hrm/save-employee-other-info";
export const updateOtherInfo = (id) => prefix + `hrm/update-other-info/${id}`;
export const deleteOtherInfo = (id) => prefix + `hrm/delete-other-info/${id}`;
export const bulkDeleteOtherInfo = prefix + "hrm/bulk-delete-other-info";

// Settings Information
export const getSettingsInfoList = prefix + "hrm/get-settings-info-list";
export const getSettingsInfoById = (id) => prefix + `hrm/get-settings-info/${id}`;
export const getSettingsInfoByEmployee = (id) => prefix + `hrm/get-settings-info-by-employee/${id}`;
export const saveUpdateSettingsInfo = prefix + "hrm/save-update-settings-info";
export const saveEmployeeSettingsInfo = prefix + "hrm/save-employee-settings-info";
export const updateSettingsInfo = (id) => prefix + `hrm/update-settings-info/${id}`;
export const deleteSettingsInfo = (id) => prefix + `hrm/delete-settings-info/${id}`;
export const bulkDeleteSettingsInfo = prefix + "hrm/bulk-delete-settings-info";

// Office/Branch
export const getOfficeList = prefix + "hrm/get-office-list";

// Employee Salary Info
export const getEmployeeSalaryInfo = (id) => prefix + `hrm/get-salary-info-by-employee/${id}`;
export const getHrmEmployeeSalaryDistribution = prefix + "hrm/get-salary-distribution";

// OT Management
export const getOTApplicableEmployees = prefix + "hrm/get-ot-applicable-employees";
export const calculateOTAmount = prefix + "hrm/calculate-ot-amount";

// Increment Management
export const getIncrementList = prefix + "hrm/get-increment-list";
export const getIncrementById = (id) => prefix + `hrm/get-increment-by-id/${id}`;
export const getIncrementsByEmployee = (id) => prefix + `hrm/get-increments-by-employee/${id}`;
export const saveUpdateIncrement = prefix + "hrm/save-update-increment";
export const updateIncrement = (id) => prefix + `hrm/update-increment/${id}`;
export const deleteIncrement = (id) => prefix + `hrm/delete-increment/${id}`;
export const approveIncrement = (id) => prefix + `hrm/approve-increment/${id}`;
export const rejectIncrement = (id) => prefix + `hrm/reject-increment/${id}`;
export const getIncrementStatistics = prefix + "hrm/get-increment-statistics";
export const generateIncrementReferenceNumber = prefix + "hrm/generate-increment-ref-no";
export const calculateSalaryComponents = prefix + "hrm/calculate-salary-components";

// Promotion Management
export const getPromotionList = prefix + "hrm/get-promotion-list";
export const getPromotionById = (id) => prefix + `hrm/get-promotion/${id}`;
export const saveOrUpdatePromotion = prefix + "hrm/save-or-update-promotion";
export const updatePromotion = (id) => prefix + `hrm/update-promotion/${id}`;
export const deletePromotion = (id) => prefix + `hrm/delete-promotion/${id}`;
export const generatePromotionReferenceNumber = prefix + "hrm/generate-promotion-ref-no";

// Claim Management
export const getClaimTypeList = prefix + "hrm/get-claim-type-list";
export const getClaimList = prefix + "hrm/get-claim-list";
export const getClaimById = (id) => prefix + `hrm/get-claim-by-id/${id}`;
export const saveUpdateClaim = prefix + "hrm/save-update-claim";
export const deleteClaim = (id) => prefix + `hrm/delete-claim/${id}`;
export const deleteClaimAttachment = (id) => prefix + `hrm/delete-claim-details-attachment/${id}`;
export const disburseClaim = prefix + "hrm/claim/{id}/disbursement";

// Meeting Managment
export const saveUpdateHrmEmployeeMeeting = prefix + "hrm/save-update-employee-meeting";
export const getHrmEmployeeMeetingList = prefix + "hrm/get-employee-meeting-list";
export const approveHrmEmployeeMeeting = prefix + "hrm/employee-meeting/approve";
export const holdHrmEmployeeMeeting = prefix + "hrm/employee-meeting/hold";
export const rejectHrmEmployeeMeeting = prefix + "hrm/employee-meeting/reject";

// HRM Reports
export const getPromotionReport = prefix + "hrm/promotion-report";
export const getNomineeReport = prefix + "hrm/nominee-report";
export const getEmployeeSummaryReport = prefix + "hrm/employee-summary-report";
export const getHrmEmployeeKpiReport = prefix + 'hrm/kpi/dashboard';

//Product Mapping Management
export const getProductMappingList = prefix + "administration/get-product-mapping-list";
export const saveUpdateProductMapping = prefix + "administration/save-update-product-mapping";

//===================== Purchase ==============================
export const saveUpdatePurRequisition = prefix + "purchase/save-update-pur-requisition";
export const getPurRequisitionList = prefix + "purchase/get-pur-requisition-list";
export const getOrderablePurchaseRequisitionList = prefix + "purchase/get-orderable-purchase-requisition-list";
export const getMergeablePurchaseRequisitionList = prefix + "purchase/get-mergable-purchase-requisition-list";
export const getSelectedPurRequisitionList = prefix + "purchase/get-selected-pur-requisition-list";
export const getPurRequisitionById = prefix + "purchase/get-pur-requisition-by-id";
// Approval api
export const getPendingPurRequisition = prefix + "purchase/get-pending-pur-requisition";
export const getPurRequisitionWithApprovalById = prefix + "purchase/get-pur-requisition-with-approval-by-id";
// Purchase requisition cnc merge
export const saveUpdatePurRequisitionMerge = prefix + "purchase/save-update-pur-requisition-merge";
export const getPurRequisitionMergeList = prefix + "purchase/get-pur-requisition-merge-list";
export const getRfqablePurRequisitionMergeList = prefix + "purchase/get-rfqable-pur-requisition-merge-list";
export const getOrderablePurRequisitionMergeList = prefix + "purchase/get-orderable-pur-requisition-merge-list";


export const getPurRequisitionMergeById = prefix + "purchase/get-pur-requisition-merge-by-id";
// Settings
export const saveUpdateEvaluationCriteria = prefix + "purchase/pur-cs-evaluation-configs/store-update";
export const getEvaluationCriteriaList = prefix + "purchase/pur-cs-evaluation-configs";
export const getEvaluationCriteriaById = prefix + "purchase/get-pur-cs-evaluation-configs-by-id";

// Purchase settings
export const saveUpdatePurLetterInfo = prefix + "purchase/save-update-pur-letter-info";
export const getPurLetterInfo = prefix + "purchase/get-pur-letter-info";
// Rfq
export const saveUpdateRfq = prefix + "purchase/save-update-rfq";
export const getRfqList = prefix + "purchase/get-rfq-list";
export const getQuotationableRfqList = prefix + "purchase/get-quotationable-rfq-list";
export const getRfqById = prefix + "purchase/get-rfq-by-id";
// Cs Qoutation
export const saveUpdateCsQuotation = prefix + "purchase/save-update-cs-quotation";
export const getCsQuotationList = prefix + "purchase/get-cs-quotation-list";
export const getCsQuotationById = prefix + "purchase/get-cs-quotation-by-id";

// Purchase Order
export const getPurOrderList = prefix + "purchase/get-pur-order-list";
export const saveUpdatePurOrder = prefix + "purchase/save-update-pur-order";
export const getPurOrderById = prefix + "purchase/get-pur-order-by-id";
export const getReceivablePurchaseOrderList = prefix + "purchase/get-receivable-purchase-order-list";

// Purchase Invoice
export const saveUpdatePurInvoice = prefix + "purchase/save-update-pur-invoice";
export const getPurInvoiceList = prefix + "purchase/get-pur-invoice-list";
export const getPurInvoiceById = prefix + "purchase/get-pur-invoice-by-id";
export const saveSupplierPayment = prefix + "purchase/save-supplier-payment";
export const getSupplierPaymentById = prefix + "purchase/get-supplier-payment-by-id";
export const getPurchaseSupplierPayments = prefix + "purchase/get-purchase-supplier-payments";

// Suppiler Selection
export const getCsQuotationEvalGenerate = prefix + "purchase/cs-quotation-evaluation-generate";
export const saveUpdateSelectedSupplier = prefix + "purchase/cs-evaluation-supplier-selection-result/store-update";
export const getSelectedSupplierList = prefix + "purchase/cs-evaluation-supplier-selection-result";
export const getSelectedSupplierById = prefix + "purchase/cs-evaluation-result-by-id";
export const getCsEvaluationById = prefix + "purchase/cs-evaluation-result-by-id";
export const getCsEvaluationByPoId = prefix + "purchase/cs-evaluation-result-by-po-id";

//puchase reports
export const getPurSupplierListReport = prefix + "purchase/pur-supplier-list-report";
export const getPurRequisitionReport = prefix + "purchase/pur-requisition-report";
export const getPurPRApprovalReport = prefix + "purchase/pur-prapproval-report";
export const getPurReqMergeReport = prefix + "purchase/pur-reqmerge-report";
export const getPurRFQGenReport = prefix + "purchase/pur-rfqgen-report";
export const getPurCSStateReport = prefix + "purchase/pur-csstate-report";
export const getPurCSApprovalReport = prefix + "purchase/pur-csapproval-report";
export const getPurPOOrderReport = prefix + "purchase/pur-poorder-report";
export const getPurPOApprovalReport = prefix + "purchase/pur-poapproval-report";
export const getPurReceiveReport = prefix + "purchase/pur-receive-report";
export const getSelectedCsQuotationList = prefix + "purchase/get-selected-cs-quotation-list";
export const getSelectedCsQuotationEvaluationList = prefix + "purchase/get-selected-cs-quotation-evaluation-list";

//===================== Attendance ==============================

//shift
export const getShiftList = prefix + "attendance/get-shift-list";
export const saveUpdateShift = prefix + "attendance/save-update-shift";

//weekend
export const getWeekendList = prefix + "attendance/get-weekend-list";
export const saveUpdateWeekend = prefix + "attendance/save-update-weekend";

// Employee wise weekend
export const getEmployeeWeekendList = prefix + "attendance/get-employee-weekend-list";
export const saveUpdateEmployeeWeekend = prefix + "attendance/save-update-employee-weekend";
export const getEmployeeWeekendDetails = (id) => `${prefix}attendance/get-employee-weekend/${id}`;

// Holiday
export const getHolidayList = prefix + "attendance/get-holiday-list";
export const saveUpdateHoliday = prefix + "attendance/save-update-holiday";

//Days
export const getDaysList = prefix + "attendance/get-days-list";

// Employee Shift Mapping
export const getEmployeeShiftMappingList = prefix + "attendance/employee-shifts";
export const saveEmployeeShiftMapping = prefix + "attendance/employee-shifts";
export const getEmployeeShiftMappingDetails = (id) => `${prefix}attendance/employee-shifts/${id}`;

//Attendance Recociliation
export const getAttendanceReconciliationList = prefix + "attendance/attendance-reconciliation";
export const getAttendanceReconciliationById = prefix + "attendance/attendance-reconciliation";
export const saveUpdateAttendanceReconciliation = prefix + "attendance/attendance-reconciliation/store";

//Attendance Upload
export const saveUpdateAttendanceUpload = prefix + "attendance/attendance-upload";

// Manual Attendance
export const saveManualAttendance = prefix + "attendance/manual-attendance-store";

// Attendance Reports
export const getAttendanceSummaryReport = prefix + "attendance/attendance-summary-report";
export const getMyDailyAttendanceReport = prefix + "attendance/attendance-own-sheet-report";
export const getEmployeeDailyAttendanceSheetReport = prefix + "attendance/employee-attendance-sheet-report";
export const getEmployeeJobCard = prefix + "attendance/employee-job-card";
export const getOvertimeReport = prefix + "attendance/overtime-report";
export const getLateEarlyReport = prefix + "attendance/late-early-report";
export const getAbsentReport = prefix + "attendance/absent-report";
export const getAttendanceRegisterReport = prefix + "attendance/attendance-register-report";
export const getShiftWiseAttendanceSummaryReport = prefix + "attendance/shift-wise-attendance-summary-report";
export const getAttendanceReconciliationReport = prefix + "attendance/attendance-reconciliation-report";
export const getWorkforceAvailabilityReport = prefix + "attendance/workforce-availability-report";
export const getAttendanceLedgerReport = prefix + "attendance/attendance-ledger";
export const getDepartmentPerformanceReport = prefix + "attendance/department-attendance-performance";
export const getAttendanceRawPunchData = prefix + "attendance/attendance-raw-punch-data";

// Employee Roster
export const rosterResource = prefix + "attendance/rosters";

//===================== Sales ==============================
//Sales Letter Setup
export const getSlsLetterInfo = prefix + "sales/get-sls-letter-info";
export const saveUpdateSlsLetterInfo = prefix + "sales/save-update-sls-letter-info";

//Color Management
export const getMarketList = prefix + "sales/get-market-list";
export const saveUpdateMarket = prefix + "sales/save-update-market";

//Sales Fixed Percentage Commission
export const getSalesFixedPercentageCommissionList = prefix + "sales/sales-commissions/fixed_percentage";
export const getSalesFixedPercentageCommissionById = prefix + "sales/sales-commissions/fixed_percentage";
export const saveUpdateFixedPercentageCommission = prefix + "sales/sales-commissions/store/fixed_percentage";

//Sales Tiered Commission
export const getSalesTieredCommissionList = prefix + "sales/sales-commissions/tiered";
export const getSalesTieredCommissionById = prefix + "sales/sales-commissions/tiered";
export const saveUpdateTieredCommission = prefix + "sales/sales-commissions/store/tiered";

//Sales Product Based Commission
export const getSalesProductBasedCommissionList = prefix + "sales/sales-commissions/product_based";
export const getSalesProductBasedCommissionById = prefix + "sales/sales-commissions/product_based";
export const saveUpdateProductBasedCommission = prefix + "sales/sales-commissions/store/product_based";

//Sales Profit Based Commission
export const getSalesProfitBasedCommissionList = prefix + "sales/sales-commissions/profit_based";
export const getSalesProfitBasedCommissionById = prefix + "sales/sales-commissions/profit_based";
export const saveUpdateProfitBasedCommission = prefix + "sales/sales-commissions/store/profit_based";

//Sales Leads
export const getSalesLeads = prefix + "sales/get-sls-leads";
export const getSalesLeadsbyId = prefix + "sales/get-sls-lead-by-id";
export const saveUpdateSalesLeads = prefix + "sales/save-update-sls-lead";
export const saveUpdateActivityLogs = prefix + "sales/save-sls-lead-activity-log";

//Sales Lead Source Types
export const getSalesLeadTypes = prefix + "sales/get-sls-lead-source-types";
export const saveUpdateSalesLeadsourceType = prefix + "sales/save-update-sls-lead-source-type";

//Sales Lead Status routes
export const getSalesLeadStatus = prefix + "sales/get-sls-lead-status";

//Sales Lead Details routes

export const getSalesLeadActivityLog = prefix + "sales/get-sls-lead-activity-log";
export const saveUpdateSalesLeadActivityLog = prefix + "sales/save-update-sls-lead-activity-log";
export const getLeadActivityLogById = prefix + "sales/save-sls-lead-activity-log";

//Sales Proposals routes

export const getSalesProposalsList = prefix + "sales/get-sls-proposals";
export const getSalesProposalbyId = prefix + "sales/get-sls-proposal-by-id";
export const saveUpdateSalesProposals = prefix + "sales/save-update-sls-proposal";
export const saveUpdateActivityLogsProposals = prefix + "sales/save-sls-proposal-activity-log";

//Sales Proposals Assigned routes

export const getSalesLeadAssigned = prefix + "sales/get-sls-lead-assigned";
export const saveUpdateSalesLeadAssigned = prefix + "sales/save-sls-lead-assigned";
export const getSalesLeadAssignedById = prefix + "sales/get-sls-lead-assigned-by-id";

//Sales Proposal Status routes
export const getSalesProposalStatus = prefix + "sales/get-sls-proposal-status";

//Sales work order status
export const getSalesWorkOrderStatusList = prefix + "sales/get-sls-workorder-status";

//Sales Work Order
export const getSalesWorkOrderList = prefix + "sales/get-sls-workorders";
export const getSalesWorkOrderById = prefix + "sales/get-sls-workorder-by-id";
export const saveUpdateSalesWorkOrder = prefix + "sales/save-update-sls-workorder";
export const getCustomerByWorkOrderId = prefix + "sales/get-inv-customer-by-workorder_id";

//Sales Work Order log
export const getSalesWorkOrderActivityLog = prefix + "sales/get-sls-workorder-activity-log/";
export const saveSalesWorkOrderActivityLog = prefix + "sales/save-sls-workorder-activity-log";

export const getSaleOrderList = prefix + "sales/get-sls-sale-orders";
export const saveUpdateSaleOrder = prefix + "sales/save-update-sls-sale-order";
export const getSaleOrderById = prefix + "sales/get-sls-sale-order-by-id";
export const getSaleOrderProcessById = prefix + "sales/get-sls-sale-order-process-by-id";

export const getSampleOrderList = prefix + "sales/get-sls-sample-orders";
export const saveUpdateSampleOrder = prefix + "sales/save-update-sls-sample-order";
    export const getSampleOrderById = prefix + "sales/get-sls-sample-order-by-id";

export const getSaleInvoiceList = prefix + "sales/get-sls-sale-invoices";
export const saveUpdateSaleInvoice = prefix + "sales/save-update-sls-sale-invoice";
export const saveUpdateSaleInvoiceTaxAdjustment = prefix + "sales/save-customer-tax-adjustment";
export const getSaleInvoiceById = prefix + "sales/get-sls-sale-invoice-by-id";

export const getSaleCustomerBalanceSummary = prefix + "sales/customer-balance-summary";
export const saleCustomerBalanceSync = prefix + "sales/customer-balance-sync"

export const getCustomerPaymentList = prefix + "sales/get-sls-customer-payments";
export const getSalePaymentList = prefix + "sales/get-sls-sale-invoices";
export const saveUpdatePaymentInvoice = prefix + "sales/save-update-sls-sale-invoice";

export const saveCustomerPayment = prefix + "sales/save-customer-payment";
export const getCustomerPaymentById = prefix + "sales/get-customer-payment-by-id";

//Sales Teams
export const getSalesTeams = prefix + "sales/sales-teams";
export const saveUpdateSalesTeam = prefix + "sales/sales-teams/store-update";

//Sales Department Target
export const getSalesDepartmentTargetList = prefix + "sales/sales-targets/department";
export const saveUpdateSalesDepartmentTarget = prefix + "sales/sales-targets/department/store-update";

//Sales Team Target
export const getSalesTeamTargetList = prefix + "sales/sales-targets/team";
export const saveUpdateSalesTeamTarget = prefix + "sales/sales-targets/team/store-update";

//Sales Employee Target
export const getSalesEmployeeTargetList = prefix + "sales/sales-targets/employee";
export const saveUpdateSalesEmployeeTarget = prefix + "sales/sales-targets/employee/store-update";
// Reports
export const getSalesStatementReports = prefix + "sales/get-sales-statement-reports";
export const getCustomerSalesReport = prefix + "sales/get-customer-sales-report";
export const getCustomerSalesOrderReport = prefix + "sales/get-customer-sales-order-report";
export const getEmployeeSalesSummeryReport = prefix + "sales/get-employee-sales-summary-report";
export const getEmployeeSalesDetailsReport = prefix + "sales/get-employee-sales-details-report";
export const getSalesCustomerKpiReport = prefix + 'sales/kpi/dashboard';
export const getSalesAcountsReceivableAging = prefix + 'sales/accounts-receivable-aging';

export const getTargetVsActual = prefix + "sales/reports/sales-target-vs-actual";
export const getSalesTargetVsActual = prefix + "sales/reports/get-sales-target-vs-actual";
export const getCommissionReport = prefix + "sales/reports/get-commission-report";

export const getPriceInquiries = prefix + "sales/get-price-inquiries";
export const saveUpdatePriceInquiry = prefix + "sales/save-update-price-inquiry";
export const getPriceInquiryById = prefix + "sales/get-price-inquiry-by-id";

export const getPriceCalculations = prefix + "sales/get-price-calculations";
export const saveUpdatePriceCalculation = prefix + "sales/save-update-price-calculation";
export const getPriceCalculationById = prefix + "sales/get-price-calculation-by-id";

//===================== Accounts ==============================
//Account Heads
export const getAccountHeadList = prefix + "accounts/account-heads";
export const getAllAccountHeadList = prefix + "accounts/all-account-heads";
export const saveUpdateAccountHead = prefix + "accounts/account-heads/store-update";
export const getAccountHeadById = prefix + "accounts/account-heads";
//Non Cash Account
export const getNonCashAccoutHeadList = prefix + "accounts/non-cash-account-heads";
//Payment account heads
export const getPaymentAccountHeadList = prefix + "accounts/payment-account-heads";

export const getCashAccountHeadList = prefix + "accounts/cash-account-heads";

//Const Centers
export const getConstCentersList = prefix + "accounts/cost-centers";
export const saveUpdateCostCenters = prefix + "accounts/cost-centers/store-update";

//Voucher
export const saveUpdateVoucher = prefix + `accounts/vouchers`;
export const getVoucherList = prefix + `accounts/vouchers`;
export const getVoucherById = prefix + `accounts/vouchers`;

//Party (Payee/Depositor)
export const getPartyList = prefix + "accounts/parties";
export const syncPartyList = prefix + "accounts/parties/sync";

//Cheque Book
export const getChequeBookList = prefix + "accounts/cheque-books";
export const getChequeList = prefix + "accounts/cheques";
export const getChequeById = prefix + "accounts/cheques";
export const saveChequeBook = prefix + "accounts/cheque-books";
export const getChequeBookById = prefix + "accounts/cheque-books";
export const updateChequeBook = prefix + "accounts/cheque-books";

//Bank
export const getBankList = prefix + "accounts/banks";   
export const getBankById = prefix + "accounts/banks";
export const saveBank = prefix + "accounts/banks";
export const updateBank = prefix + "accounts/banks";

//Branch
export const getBankBranchList = prefix + "accounts/branches";   
export const getBankBranchById = prefix + "accounts/branches";
export const saveBankBranch = prefix + "accounts/branches";
export const updateBankBranch = prefix + "accounts/branches";

//Bank Account
export const getBankAccountList = prefix + "accounts/bank-accounts";   
export const getBankAccountById = prefix + "accounts/bank-accounts";
export const saveBankAccount = prefix + "accounts/bank-accounts";
export const updateBankAccount = prefix + "accounts/bank-accounts";

//VAT BOOK
export const getVatRegister = prefix + `accounts/vat-book/vat-register`;
export const vatPayout = prefix + `accounts/vat-book/vat-payout`;
export const vatPaymentList = prefix + `accounts/vat-book/vat-payment-list`;
export const vatChallanInfoStore = prefix + `accounts/vat-book/vat-challan-update`;
export const vatPaymentDetails = prefix + `accounts/vat-book/vat-payment-details`;

// TAX BOOK
export const getTaxRegister = prefix + `accounts/tax-book/tax-register`;
export const taxPayout = prefix + `accounts/tax-book/tax-payout`;
export const taxPaymentList = prefix + `accounts/tax-book/tax-payment-list`;
export const taxChallanInfoStore = prefix + `accounts/tax-book/tax-challan-update`;
export const taxPaymentDetails = prefix + `accounts/tax-book/tax-payment-details`;

//Bank Reconciliation
export const bankReconciliationRecord = prefix + `accounts/bank-reconciliation`;
export const bankReconciliationCheckout = prefix + `accounts/bank-reconciliation-checkout`;
export const bankReconciliationUndoCheckout = prefix + `accounts/bank-reconciliation-undo-checkout`;
export const bankReconciliationStatement = prefix + `accounts/bank-reconciliation-statement`;

//Money Requisition
export const getMoneyRequisitionList = prefix + `accounts/money-requisitions`;
export const getMoneyRequisitionById = prefix + `accounts/money-requisitions`;
export const saveUpdateMoneyRequisition = prefix + `accounts/money-requisitions`;
export const disburseMoneyRequisition = prefix + `accounts/money-requisitions`;

//Employee Advance
export const getEmployeeAdvanceSettlesList = prefix + `accounts/employee-advance-settles`;
export const getEmployeeAdvanceSettlesById = prefix + `accounts/employee-advance-settles`;
export const saveUpdateEmployeeAdvanceSettles = prefix + `accounts/employee-advance-settles`;


//===================== Asset ==============================

//Category
export const getAssetCategoryList = prefix + "assets/category";
export const saveUpdateAssetCategory = prefix + "assets/category/store";
export const getAssetCategoryById = prefix + "assets/category";

//Depreciation method
export const getAssetDepreciationMethodList = prefix + "assets/depreciation-methods";
export const getAssetDepreciationMethodById = prefix + "assets/depreciation-methods";

//Status Type
export const getAssetStatusTypesList = prefix + "assets/status";
export const saveUpdateAssetStatusType = prefix + "assets/status/store";
export const getAssetStatusTypeById = prefix + "assets/status";

//Location
export const getAssetLocationsList = prefix + "assets/location";
export const saveUpdateAssetLocation = prefix + "assets/location/store";
export const getAssetLocationById = prefix + "assets/location";

//Asset Mapping
export const getAssetMapplingsList = prefix + "assets/category-account-head-mapping";
export const saveUpdatAssetMapping = prefix + "assets/category-account-head-mapping/store";
export const getAssetMapplingById = prefix + "assets/category-account-head-mapping";

//New Asset Registration
export const getAssetRegistrationsList = prefix + "assets/asset-register";
export const saveUpdateAssetRegistration = prefix + "assets/asset-register/store";
export const getAssetRegistrationById = prefix + "assets/asset-register";

//Asset Components
export const getAssetComponentsList = prefix + "assets/asset-component";
export const saveUpdateAssetComponent = prefix + "assets/asset-component/store";
export const getAssetComponentById = prefix + "assets/asset-component";

//Asset Documents
export const getAssetDocumentsList = prefix + "assets/asset-document";
export const saveUpdateAssetDocument = prefix + "assets/asset-document/store";
export const getAssetDocumentById = prefix + "assets/asset-document";

//Asset Assignments and Unassignments
export const getAssetAssignmentsList = prefix + "assets/asset-assignment";
export const getAssetAssignmentById = prefix + "assets/asset-assignment";

export const saveUpdateAssetAssignment = prefix + "assets/asset-assignment/store";
export const saveUpdateAssetUnassignment = prefix + "assets/asset-unassignment/store";

//Asset Depreciation
export const getAssetDepreciationsList = prefix + "assets/asset-depreciation";
export const saveUpdateAssetDepreciation = prefix + "assets/asset-depreciation/store";
export const getAssetDepreciationById = prefix + "assets/asset-depreciation";
export const getAssetRegisterDepreciationsList = prefix + "assets/asset-register-deprecations";

//Asset Transfer
export const getAssetTransferList = prefix + "assets/asset-transfer";
export const getAssetRegisterTransfersList = prefix + "assets/asset-register-transfers";
export const saveUpdateAssetTransfer = prefix + "assets/asset-transfer/store";
export const getAssetTransferById = prefix + "assets/asset-transfer";
export const getAssetTransferHistory = prefix + "assets/asset-register-transfers";

//Asset Maintenance
export const getAssetMaintenanceList = prefix + "assets/asset-maintenance";
export const getAssetRegisterMaintenancesList = prefix + "assets/asset-register-maintenances";
export const saveUpdateAssetMaintenance = prefix + "assets/asset-maintenance/store";
export const getAssetMaintenanceById = prefix + "assets/asset-maintenance";
export const getAssetMaintenanceHistory = prefix + "assets/asset-register-maintenances";

//Asset Disposal
export const getAssetDisposalList = prefix + "assets/asset-disposal";
export const getAssetRegisterDisposalsList = prefix + "assets/asset-register-disposals";
export const saveUpdateAssetDisposal = prefix + "assets/asset-disposal/store";
export const getAssetDisposalById = prefix + "assets/asset-disposal";
export const getAssetDisposalHistory = prefix + "assets/asset-register-disposals";

//Asset Preparation
export const getAssetPreparationList = prefix + "assets/asset-preparation";
export const getAssetRegisterPreparationsList = prefix + "assets/asset-register-preparations";
export const saveUpdateAssetPreparation = prefix + "assets/asset-preparation/store";
export const getAssetPreparationById = prefix + "assets/asset-preparation";
export const getAssetPreparationHistory = prefix + "assets/asset-register-preparations";

//Asset Acquisition (Purchase Received)
export const getAssetAcquisitionList = prefix + "assets/asset-register-acquisition";
export const saveUpdateAssetAcquisition = prefix + "assets/asset-register-acquisition/store";
export const getAssetAcquisitionById = prefix + "assets/asset-register-acquisition";

// Asset Reports 
export const getAssetSummaryReport = prefix + "assets/reports/asset-summary"

//===================== Accounts Reports ==============================
export const getDayBookReport = prefix + "accounts/reports/day-book";
export const getCashBookReport = prefix + "accounts/reports/cash-book";
export const getBankBookReport = prefix + "accounts/reports/bank-book";
export const getLedgerReport = prefix + "accounts/reports/ledger";
export const getTrialBalanceReport = prefix + "accounts/reports/trial-balance";
export const getBalanceSheetReport = prefix + "accounts/reports/balance-sheet";
export const getIncomeStatementReport = prefix + "accounts/reports/income-statement";
export const getCashFlowReport = prefix + "accounts/reports/cash-flow";
export const getChangesInEquityReport = prefix + "accounts/reports/changes-in-equity";
export const getReceiptAndPaymentReport = prefix + "accounts/reports/receipt-and-payment";
export const getReceiptPaymentReport = prefix + "accounts/reports/receipt-payment-statement";

// Accounts Dropdowns
export const getAccountHeads = prefix + "accounts/all-account-heads";
export const getPaymentAccountHeads = prefix + "accounts/payment-account-heads";
export const getCostCenters = prefix + "accounts/cost-centers";

//===================== Leave Management Module ==============================

//Settings
export const leaveType = prefix + `leave/leave-types`;
export const saveUpdateLeaveType = prefix + `leave/leave-types/store`;

//Leave Applocation
export const leaveApplicationList = prefix + `leave/leave-applications`;
export const latestLeaveApplication = prefix + "leave/leave-applications/{id}/latest";
export const employeeLeaveBalanceById = prefix + "leave/employee-leave/{id}/balances"
export const saveUpdateLeaveApplication = prefix + `leave/leave-applications/store`;
export const leaveDayCount = prefix + `leave/leave-applications/leave-day-count`;

//Official
export const leaveList = prefix + `leave-applications`;
export const saveUpdateLeave = prefix + `leave/leave-applications/store`;

//Leave Process
export const leaveProcess = prefix + `leave/leave-balances/store`;
export const employeeLeaveProcess = prefix + `leave/leave-balances/by-employee/store`;
export const leaveBalance = prefix + `leave/leave-balances`;
export const employeeLeaveBalance = prefix + `leave/employee-leave-balances`;

//Leave Summary Report
export const getleaveSummaryReport = prefix + `leave/leave-summary-report`;

//Leave Details Report
export const getleaveDetailsReport = prefix + `leave/leave-details-report`;

//Leave Employee Wise Summary Report
export const getLeaveEmployeeWiseSummaryReport = prefix + `leave/employee-wise-leave-summary`;

//Leave Earned Register Report
export const getLeaveEarnedRegisterReport = prefix + `leave/earned-leave-register`;


//===================== Payroll Management Module ==============================

//Payroll Settings
export const salaryComponentList = prefix + `payroll/salary-components`;
export const getSalaryComponentById = prefix + `payroll/salary-components`;
export const saveUpdateSalaryComponent = prefix + `payroll/salary-components/store`;

//Salary Process
export const runSalaryProcess = prefix + `payroll/run-salary-process/store`;
export const getSalaryProcessList = prefix + `payroll/salary-process`;
export const getSalaryProcessById = prefix + `payroll/salary-process`;

//Employee Salary
export const getEmployeeSalaryList = prefix + `payroll/employee-salary-list`;
export const getEmployeeSalaryDetails = prefix + `payroll/employee-salary-details`;

//Salary Ready Attendance
export const getSalaryReadyAttendanceList = prefix + `payroll/salary-ready-attendance`;
export const getSalaryReadyAttendanceById = prefix + `payroll/salary-ready-attendance`;
export const saveUpdateSalaryReadyAttendance = prefix + `payroll/salary-ready-attendance/store`;

//Employee Loans
export const getEmployeeLoanList = prefix + `payroll/employee-loans`;
export const getEmployeeLoanById = prefix + `payroll/employee-loans`;
export const storeEmployeeLoan = prefix + `payroll/employee-loans`;

//Salary Payments
export const getSalaryPaymentList = prefix + `payroll/salary-payments`;
export const getSalaryPaymentById = prefix + `payroll/salary-payments`;
export const saveUpdateSalaryPayment = prefix + `payroll/salary-payments/store`;

//Bonus process
export const getBonusTypeList = prefix + `payroll/bonus-types`;
export const getBonusTypeById = prefix + `payroll/bonus-types`;
export const saveUpdateBonusType = prefix + `payroll/bonus-types/store`;
export const saveUpdateBonusProcess = prefix + `payroll/run-bonus-process/store`;
export const bonusProcessList = prefix + `payroll/bonus-process`;
export const employeeBonusList = prefix + `payroll/employee-bonus-list`;
export const employeeBonusDetails = prefix + `payroll/employee-bonus-details`;

//Bonus Payment
export const bonusPayment = prefix + `payroll/bonus-payments/store`;
export const bonusPaymentList = prefix + `payroll/bonus-payments`;

//Bonus Reports
export const getBonusProcessReport = prefix + `payroll/bonus-reports/process`;
export const getBonusSummaryRegisterReport = prefix + `payroll/bonus-reports/summary-register`;
export const getBonusPaymentRegisterReport = prefix + `payroll/bonus-reports/payment-register`;
export const getBonusBankAdviceReport = prefix + `payroll/bonus-reports/bank-advice`;
export const getEmployeeBonusHistoryReport = prefix + `payroll/bonus-reports/employee-history`;
export const getBonusComparativeReport = prefix + `payroll/bonus-reports/comparative`;
export const getBonusAgingReport = prefix + `payroll/bonus-reports/aging`;
export const getBonusTrendReport = prefix + `payroll/bonus-reports/trend`;

//Salary Reports
export const getMonthlySalaryReport = prefix + `payroll/salary-reports/monthly-sheet`;
export const getSalarySummaryReport = prefix + `payroll/salary-reports/summary`;
export const getSalaryPayRegisterReport = prefix + `payroll/salary-reports/pay-register`;
export const getSalaryBankAdviceReport = prefix + `payroll/salary-reports/bank-advice`;
export const getSalaryOutstandingReport = prefix + `payroll/salary-reports/outstanding`;
export const getemployeeSalaryHistoryReport = prefix + `payroll/salary-reports/employee-history`;
export const getSalaryAgingReport = prefix + `payroll/salary-reports/aging`
export const getAllowanceDeductionBreakupReport = prefix  + `payroll/salary-reports/allowance-deduction-breakup`;
export const getTaxSummaryReport = prefix +  `payroll/salary-reports/tax-summary`;
export const getSalaryTrendReport = prefix + `payroll/salary-reports/salary-trend`;
export const getOtIncentiveReport = prefix + `payroll/salary-reports/ot-incentive`;
export const getFullPayrollLedgerReport = prefix + `payroll/salary-reports/full-ledger`;

//===================== Documents ==============================

//Folders Managements
export const getDocumentsFolderList = prefix + "document/folders";
export const downloadFolder = prefix + "document/folders";
export const saveDocumentsFolder = prefix + "document/folders";
export const updateDocumentFolder = prefix + "document/folders";
export const deleteDocumentsFolder = prefix + "document/folders"

//Files Managements
export const getDocumentsFileList = prefix + "document/files";
export const downloadFile = prefix + "document/files";
export const saveDocumentsFile = prefix + "document/files/upload";
export const deleteDocumentsFile = prefix + "document/files";

//Share Managements
export const shareDocuments = prefix + "document/share";
export const getSharedUsersList = prefix + "document/shared-users";
export const getSharedWithMeList = prefix + "document/shared-with-me";
export const getSharedTreeList = prefix + "document/shared-tree";

//Recent Managements
export const getRecentDocumentsList = prefix + "document/files/recent";

//Starred Managements
export const getStarredDocumentsList = prefix + "document/starred";
export const saveStarredDocuments = prefix + "document/star";

//Archive Managements
export const getArchivedDocumentsList = prefix + "document/archived";
export const saveArchiveDocument = prefix + "document/archive";
export const restoreArchivedDocument = prefix + "document/restore";

//Trash Managements
export const getTrashDocumentsList = prefix + "document/trash";
export const forceDeleteTrashDocument = prefix + "document/trash/force";
export const restoreTrashDocument = prefix + "document/trash/restore";

//===================== LC Management ==============================

// Currency (from Sales module)
export const getCurrencyList = prefix + "sales/get-currency";

// LC Banks
export const getLcBankList = prefix + "lc/banks";
export const getLcBankById = prefix + "lc/banks/";
export const saveUpdateLcBank = prefix + "lc/banks/store";

// LC Payment Terms
export const getLcPaymentTermList = prefix + "lc/payment-terms";
export const getLcPaymentTermById = prefix + "lc/payment-terms/";
export const saveUpdateLcPaymentTerm = prefix + "lc/payment-terms/store";

// LC Incoterm
export const getLcIncotermList = prefix + "lc/incoterm";
export const getLcIncotermById = prefix + "lc/incoterm/";
export const saveUpdateLcIncoterm = prefix + "lc/incoterm/store";

// LC Types
export const getLcTypeList = prefix + "lc/types";
export const getLcTypeById = prefix + "lc/types/";
export const saveUpdateLcType = prefix + "lc/types/store";

// LC Ports
export const getLcPortList = prefix + "lc/ports"; 
export const getLcPortById = prefix + "lc/ports/";
export const saveUpdateLcPort = prefix + "lc/ports/store";

// LC Shipping Methods
export const getLcShippingMethodList = prefix + "lc/shipping-methods";
export const getLcShippingMethodById = prefix + "lc/shipping-methods/";
export const saveUpdateLcShippingMethod = prefix + "lc/shipping-methods/store";

// LC Exchange Rate
export const getLcExchangeRateList = prefix + "lc/exchange-rate";
export const getLcExchangeRateById = prefix + "lc/exchange-rate/";
export const saveUpdateLcExchangeRate = prefix + "lc/exchange-rate/store";

// LC Import - Proforma Invoice (PI)
export const getLcImportPiList = prefix + "lc-import/pi/list";
export const getLcImportPiById = prefix + "lc-import/pi/";
export const saveUpdateLcImportPi = prefix + "lc-import/pi/store";
export const getLcImportPiUnassigned = prefix + "lc-import/pi/unassigned";
export const getLcImportPiAvailableForLc = prefix + "lc-import/pi/available-for-lc/";

// LC Import - LC Master
export const getLcImportLcMasterList = prefix + "lc-import/lc/list";
export const getLcImportLcMasterById = prefix + "lc-import/lc/";
export const saveUpdateLcImportLcMaster = prefix + "lc-import/lc/store";

// LC Import - LC Amendment
export const getLcImportLcAmendmentList = prefix + "lc-import/lc/amendment/list";
export const getLcImportLcAmendmentById = prefix + "lc-import/lc/amendment/";
export const saveUpdateLcImportLcAmendment = prefix + "lc-import/lc/amendment/store";

// LC Import - LC Shipment
export const getLcImportLcShipmentList = prefix + "lc-import/lc/shipment/list";
export const getLcImportLcShipmentById = prefix + "lc-import/lc/shipment/";
export const saveUpdateLcImportLcShipment = prefix + "lc-import/lc/shipment/store";

// LC Document Types
export const getLcDocumentTypeList = prefix + "lc/document-types";
export const getLcDocumentTypeById = prefix + "lc/document-types/";
export const saveLcDocumentType = prefix + "lc/document-types"; 
export const updateLcDocumentType = prefix + "lc/document-types/"; 


// LC Import - GRN
export const getLcImportGnrList = prefix + "lc-import/gnr/list";
export const getLcImportGnrById = prefix + "lc-import/gnr/";
export const saveUpdateLcImportGnr = prefix + "lc-import/gnr/store";
export const getReceivableLcImportGnrList = prefix + "lc-import/gnr/get-receivable/gnr-list";

// LC Import - LC Costing
export const getLcImportLcCostingList = prefix + "lc-import/lc-costing";
export const getLcImportLcCostingById = prefix + "lc-import/lc-costing/";
export const saveUpdateLcImportLcCosting = prefix + "lc-import/lc-costing/store";

// LC Export - Documents
export const getLcExportDocumentList = prefix + "lc-export/documents";
export const getLcExportDocumentById = prefix + "lc-export/documents/";   
export const saveLcExportDocument = prefix + "lc-export/documents";       
export const updateLcExportDocument = prefix + "lc-export/documents/";    
export const getLcExportDocumentResource = prefix + "lc-export/documents";

// LC Import - Documents
export const getLcImportDocumentList = prefix + "lc-import/documents";
export const getLcImportDocumentById = prefix + "lc-import/documents/";   
export const saveLcImportDocument = prefix + "lc-import/documents";      
export const updateLcImportDocument = prefix + "lc-import/documents/";   

// LC Import - Reports
export const getLcImportShipmentReport = prefix + "lc-import/reports/lc-import-shipments";
export const getLcImportAgingReport = prefix + "lc-import/reports/lc-import-aging";
export const getLcImportSupplierWiseReport = prefix + "lc-import/reports/supplier-wise-lc-import";
export const getLcImportBankWiseReport = prefix + "lc-import/reports/bank-wise-lc-import";
export const getLcImportPiAllocationReport = prefix + "lc-import/reports/lc-import-pi-allocation";
export const getLcImportRegisterReport = prefix + "lc-import/reports/lc-import-register";
export const getLcImportGrnReport = prefix + "lc-import/reports/lc-import-grn";
export const getLcImportCostingSummaryReport = prefix + "lc-import/reports/lc-import-costing-summary";
export const getLcImportCostingHistoryReport = prefix + "lc-import/reports/lc-import-costing-history";


export const getLcExportPiList = prefix + "lc-export/pi/list";
export const getLcExportPiById = prefix + "lc-export/pi/";
export const saveUpdateLcExportPi = prefix + "lc-export/pi/store";
export const getLcExportPiUnassigned = prefix + "lc-export/pi/unassigned";
export const getLcExportPiAvailableForLc = prefix + "lc-export/pi/available-for-lc/";

// LC Export - LC Master
export const getLcExportLcMasterList = prefix + "lc-export/lc/list";
export const getLcExportLcMasterById = prefix + "lc-export/lc/";
export const saveUpdateLcExportLcMaster = prefix + "lc-export/lc/store";

export const saveUpdateLcExportLcCommercialInvoice = prefix + "lc-export/commercial-invoice/store";
export const getExportLcCommercialInvoiceList = prefix + "lc-export/commercial-invoice/list";
export const getExportLcCommercialInvoice = prefix + "lc-export/commercial-invoice";



//===================== Project ==============================
//Activity
export const getProjectActivityList = prefix + "project/get-project-activity-list";
export const saveUpdateProjectActivity = prefix + "project/save-update-activity";
//Type of Activity 
export const getProjectSubActivityList = prefix + "project/get-project-sub-activity-list";
export const saveUpdateProjectSubActivity = prefix + "project/save-update-type-of-activity";
// Contacted By
export const getContactList = prefix + "project/get-contact-list";
export const saveUpdateContact = prefix + "project/save-update-contact";
// Author
export const saveUpdateAuthor = prefix + "project/save-update-author";
export const getAuthorList = prefix + "project/get-author-list";
// Project Type
export const saveUpdateProjectType = prefix + "project/save-update-project-type";
export const getProjectTypeList = prefix + "project/get-project-type-list";
// project theme
export const saveUpdateProjectTheme = prefix + "project/save-update-project-theme";
export const getProjectThemeList = prefix + "project/get-project-theme-list";
// Project 
export const getProjectList = prefix + "project/get-project-list";
export const saveUpdateProject = prefix + "project/save-update-project";
export const deleteProject = prefix + "project/delete-project";
export const getProjectListbyId = prefix + "project/get-project-list-by-id";
export const getProjectActivityLogById = prefix + "project/get-project-activity-log-by-id";
export const saveUpdateProjectDetail = prefix + "project/save-update-project-detail";
// Projects
export const getProjectTrainingList = prefix + "project/get-project-training-list";
export const saveUpdateProjectTraining = prefix + "project/save-update-project-training";
export const deleteProjectTraining = prefix + "project/delete-project-training";
export const generateProjectTrainingCode = prefix + "project/generate-project-training-code";
// project template
export const saveUpdateProgressTemplate = prefix + "project/save-update-progress-template";
export const getProgressTemplateList = prefix + "project/get-progress-template-list";
export const  getProgressTemplateListbyId= prefix + "project/get-progress-template-list-by-id";
//assign template

export const saveUpdateProjectAssignTemplate = prefix + "project/save-update-project-assign-template";
export const getProgressList = prefix + "project/progress-list";
export const getProgressSummary = prefix + "project/progress-summary";
export const getProjectBudgetList = prefix + "project/get-project-budget-list";

// ================================ Resource Moddule ======================

export const purposeResource = prefix + "master-data/purposes";


// ================================ Production ======================

export const productionTempleteResource = prefix + "prd/production-templates";
export const productionTemplateCalculateResource = (templateId) => `${productionTempleteResource}/${templateId}/calculate`;
export const productionRequisitionResource = prefix + "prd/production-requisitions";
export const productionRequisitionReceiveResource = prefix + "prd/production-requisition-receives";
export const productionSaleOrderResource = prefix + "prd/production-sales-orders";
export const productionRawMaterialInventoryList = prefix + "prd/raw-inventory-list";
export const productionFinishedGoodInventoryList = prefix + "prd/finished-goods-inventory-list";

export const prdProductionResource = prefix + "prd/productions";
export const prdDeliveryResource = prefix + "prd/production-delivery";
export const productionConsumptionReport = prefix + "prd/consumption";
export const productionCostingReport = prefix + "prd/costing";
export const productionVsDeliveryReport = prefix + "prd/production-vs-delivery";
export const productionFinishedGoodsStockReport = prefix + "prd/fg-stock";
export const productionWastageReport = prefix + "prd/wastage";
export const productionEfficiencyReport = prefix + "prd/efficiency";
export const productionBomVarianceReport = prefix + "prd/bom-variance";
export const productionDailySummaryReport = prefix + "prd/daily-summary";

// ============================= Budget Module =========================

// settings
export const budgetHeadResource = prefix + "budget/budget-heads";
export const budgetSubHeadResource = prefix + "budget/budget-sub-heads";
export const budgetTypeResource = prefix + "budget/budget-types";

// budgets

export const budgetResource = prefix + "budget/budgets";
export const budgetReviseResource = (id) => `${prefix}budget/budgets/${id}/revise`;
export const budgetAttachAccountsResource = prefix + "budget/attach-accounts";
export const budgetReleaseResource = prefix + "budget/budget-releases";

// Reports
export const budgetVarianceReport = prefix + "budget/report/budget-variance";
export const budgetConsumptionReport = prefix + "budget/report/budget-consumption";
export const budgetOverrunReport = prefix + "budget/report/budget-overrun";
export const budgetSummaryReport = prefix + "budget/report/budget-summary";



// Read-only Production-stage RM / PM and Finished Goods master + movement history
export const productionInventoryStock = prefix + "prd/production-inventory";
